export const MaterialSort = {
    cND: 1,
    bulky13: 2,
    bNB: 3,
    roofing: 4,
    concrete: 5,
    comix: 6,
    concreteRebar: 7,
    asphalt: 8,
};
export const BasicMaterialsInfo = [
    {
        material: 'cND',
        allowForLowerTonLimit: false,
        allowOnlineCheckout: false,
        doesNotService: false,
        sizes: [],
        tax: false,
        type: '',
    },
    {
        material: 'bulky13',
        allowForLowerTonLimit: false,
        allowOnlineCheckout: false,
        doesNotService: false,
        sizes: [],
        tax: false,
        type: '',
    },
    {
        material: 'bNB',
        allowForLowerTonLimit: false,
        allowOnlineCheckout: false,
        doesNotService: false,
        sizes: [],
        tax: false,
        type: '',
    },
    {
        material: 'roofing',
        allowForLowerTonLimit: false,
        allowOnlineCheckout: false,
        doesNotService: false,
        sizes: [],
        tax: false,
        type: '',
    },
    {
        material: 'concrete',
        allowForLowerTonLimit: false,
        allowOnlineCheckout: false,
        doesNotService: false,
        sizes: [],
        tax: false,
        type: '',
    },
    {
        material: 'comix',
        allowForLowerTonLimit: false,
        allowOnlineCheckout: false,
        doesNotService: false,
        sizes: [],
        tax: false,
        type: '',
    },
    {
        material: 'concreteRebar',
        allowForLowerTonLimit: false,
        allowOnlineCheckout: false,
        doesNotService: false,
        sizes: [],
        tax: false,
        type: '',
    },
    {
        material: 'asphalt',
        allowForLowerTonLimit: false,
        allowOnlineCheckout: false,
        doesNotService: false,
        sizes: [],
        tax: false,
        type: '',
    },
];
//# sourceMappingURL=materials-info.js.map